import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {QuoteCollation, QuotePageDataVaps} from '../../../models/quote.model';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';
import {Question} from '../../../models/underwriter.model';

@Component({
    selector: 'app-vaps-general-one',
    templateUrl: './vaps-general-one.component.html',
    styleUrls: ['./vaps-general-one.component.scss'],
    standalone: false
})
export class VapsGeneralOneComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() collations: QuoteCollation[];
  @Input() question: Question;
  @Input() currentVap: QuotePageDataVaps;
  @Input() productId: any;
  @Input() addAddons = false;
  maskOptions: NgxCurrencyConfig;
  @Output() addAddonsChanged = new EventEmitter<boolean>();

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.addAddons?.currentValue === true) {
      this.calculate();
      this.addAddonsChanged.emit(false);
    }
  }

  ngAfterViewInit(): void {
    this.maskOptions = {
      max: this.question?.max_val,
      min: null,
      allowZero: true,
      nullable: false,
      inputMode: NgxCurrencyInputMode.Financial,
      align: 'left',
      allowNegative: false,
      prefix: 'R ',
      decimal: '.',
      suffix: '',
      thousands: ' ',
      precision: 0
    };
  }

  calculate(): void {
    console.log('Calculate...');
  }

}
